import { render, staticRenderFns } from "./ProgressStat.vue?vue&type=template&id=f00da610"
import script from "./ProgressStat.vue?vue&type=script&lang=js"
export * from "./ProgressStat.vue?vue&type=script&lang=js"
import style0 from "./ProgressStat.vue?vue&type=style&index=0&id=f00da610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports